import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const LogoBlack = ({className}) => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "logo-black@2x.png" }) {
          childImageSharp {
            fixed(width: 134, height: 50) {
              ...GatsbyImageSharpFixed_tracedSVG
            }
          }
        }
      }
    `}
    render={data => <Img fadeIn={false} className={className} critical={true} fixed={data.file.childImageSharp.fixed} />}
  />
)
export default LogoBlack
